import React, { useEffect, useState } from "react";
import { Redirect, useHistory, useLocation } from "react-router-dom";
import PageLayout from "../../../layouts/application/Page/Layout";
import { routes } from "../../../routes/Application/routes";
import LoaderComponent from "../../../components/molecules/Loaders/Loader";
import { validateUserToken } from "../../../api/authorization";
import { useUserData } from "../../../contexts/user";

const MagicLogin = () => {
  const { search } = useLocation();
  const [loading, setLoading] = useState(true);
  const [userValidated, setUserValidated] = useState(false);
  const history = useHistory();

  const { fetchUser, setLead, clearLead } = useUserData();

  useEffect(() => {
    const token = new URLSearchParams(search).get("userToken") || "";
    localStorage.removeItem("screenTrackingId");
    localStorage.removeItem("userId");
    clearLead();
    validateUserToken(token)
      .then(async (payload) => {
        const { screenTrackingId, user, lead, otpRequired } = payload;
        if (screenTrackingId) {
          localStorage.setItem("screenTrackingId", screenTrackingId);
        }
        if (user?.id) {
          localStorage.setItem("userId", user.id);
        }
        if (lead?.id) {
          localStorage.setItem("userToken", token);
          setLead(lead.id);
          if (otpRequired) {
            history.push("/application/verification");
            return;
          }
        }
        localStorage.setItem("userToken", token);
        localStorage.removeItem("isProcessingApplication");
        setUserValidated(true);
        fetchUser();
      })
      .catch(console.log)
      .finally(() => setLoading(false));
  }, []);

  const route = routes.MAGIC_LOGIN;
  return (
    <PageLayout route={route}>
      {loading && <LoaderComponent position="center" size="18" />}
      {userValidated && <Redirect to="/application" />}
    </PageLayout>
  );
};

export default MagicLogin;
